import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { UploadModule } from '@progress/kendo-angular-upload';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { GridService } from 'app/services/grid.service';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ConfigService } from '../../services/config.service';
import { TranslocoPipe } from '@ngneat/transloco';
import { ButtonsModule } from '@progress/kendo-angular-buttons'
import { SVGIcon, saveIcon, pencilIcon, trashIcon, plusCircleIcon, cancelCircleIcon, checkCircleIcon } from '@progress/kendo-svg-icons';
import { FuseAlertComponent } from '@fuse/components/alert';
import { DrakeUserComponent } from '../drake-user/drake-user.component';
import {SchedulerModelFields, SchedulerModule } from '@progress/kendo-angular-scheduler'
import { Router } from '@angular/router';

@Component({
    selector: 'app-drake-calendar-view',
    templateUrl: './drake-calendar-view.component.html',
    styleUrls: ['./drake-calendar-view.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        InputsModule,
        DropDownsModule,
        UploadModule,
        DateInputsModule,
        FormsModule,
        MatIconModule,
        TranslocoPipe,
        ButtonsModule,
        FuseAlertComponent,
        DrakeUserComponent,
        SchedulerModule
    ]
})
export class DrakeCalendarViewComponent implements AfterViewInit,OnInit,OnChanges {

    @Input() public scope: string = '';
    @Input() public viewCode: string = '';
    @Input() public filter: string = '{}';
    @Input() public sort: string = '{}';
    @Input() public commandName: string = 'READ';
    @Input() public idField: string = '';
    @Input() public titleField: string = '';
    @Input() public descriptionField: string = '';
    @Input() public startField: string = '';
    @Input() public endField: string = '';

    public data: Array<any> = [];
    public gridData: any[] = [];
    public gridView: any[];
    public items: any[];
    public eventFields:SchedulerModelFields ;
    constructor(
        private gridService: GridService,
        private router: Router
    ) {

    }

    ngOnInit(): void {
        this.eventFields= {
            id: this.idField,
            title: this.titleField,
            description: this.titleField,
            start: this.startField,
            end: this.endField

        }
        
    }

    ngAfterViewInit(): void { 

    }



    loadGridConfiguration(): void {
        if (!this.viewCode || !this.scope || !this.commandName) {
            return; // Ensure that all necessary data is available before proceeding
        }

        // Carica la configurazione della griglia
        this.gridService.getScopeView(this.viewCode).subscribe(
            (viewConfig: any) => {

                this.loadGridData();
            },
            (error) => {
                console.error('Errore durante il caricamento della configurazione della griglia', error);
            }
        );
    }

    loadGridData(): void {
        this.gridView = [];
        const requestData = {
            ViewCode: this.viewCode,
            Filter: this.filter,
            Sort: this.sort,
            Page: 0,
            PageSize: 0,
            Language: "",
            Cache: false,
            ExtraData: {}
        };
        console.log('requestData: ', requestData);
        this.gridService.getScopeData(this.scope, this.commandName, requestData).subscribe(
            (response: any) => {
                this.gridData = response.data.map((item: any) => {
                    for (let key in item) {
                        if (item[key] === null || item[key] === undefined) {
                            item[key] = '';
                        }
                    }
                    return item;
                });
                this.gridView = [...this.gridData];
                this.gridView.forEach(row => {
                    row[this.eventFields.start] = new Date(row[this.eventFields.start]);
                    row[this.eventFields.end] = new Date(row[this.eventFields.end]);
                })

                this.items = this.gridView;
            },
            (error) => {
                console.error('Error loading grid data', error);
                console.error('Request Data:', requestData);
            }
        );
    }

    ngOnChanges(changes) {
        console.log('changes',changes);
        if ((changes.scope && changes.scope.currentValue != '') || (changes.viewCode && changes.viewCode.currentValue != ''))
            this.loadGridConfiguration();
    }

    onSelectionChange(event: any) {
  
    }

    slotDblClickHandler(ev:any){
        this.router.navigate([`/d/${this.scope}/f`]);
    }

    eventDblClickHandler(ev:any){
        this.router.navigate([`/d/${this.scope}/f/${ev.event.id}`]);

    }
    
}
